import { required, email, minLength, maxLength, helpers } from "@vuelidate/validators";

export const loginPasswordValidations = () => ({
  required,
  minLength: minLength(8)
});

export const passwordValidations = () => ({
  ...loginPasswordValidations(),
  upperCase: helpers.regex(/\p{Lu}/u),
  lowerCase: helpers.regex(/\p{Ll}/u),
  numbers: helpers.regex(/\d+/),
  nonAlpha: helpers.regex(/[~!^@#$%&*_\-+=`|(){}[\]:;"'<>,.?/]+/)
});

export const phoneValidations = () => ({
  required,
  minLength: minLength(14),
  maxLength: maxLength(14)
});

export const emailValidation = () => ({
  required,
  email
});

export const requiredValidation = () => ({ required });
